import { Alert } from 'react-bootstrap';
import useAPIError from '../../hooks/apiError.context';
import './style.scss';

const APIErrorNotification = () => {
  const { error, removeError } = useAPIError();
  const showError = !!error;

  if (!error) {
    return null;
  }

  return (
    <Alert
      className="float"
      show={showError}
      variant={error.status}
      onClose={() => removeError()}
      dismissible>
      {error.message}
    </Alert>
  );
};

export default APIErrorNotification;
